module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-2.10528ccd.webp";